import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { verificarLogin, recuperarSenha } from '../../../firebase/CRUD'

import Input from '../../layout/Input/Input'
import Button from '../../layout/Button/Button'
import style from './login.module.css'

import { useToast } from '../../../hooks/Toast'

export default function FormLogin(){
    const [formData, setFormData] = useState({
        email: '',
        senha:''
    })
    const [enviandoRecuperacao, setEnviandoRecuperacao] = useState(false)
    const {mostrarAviso} = useToast()
   
    const navigate = useNavigate()
   
    const handleInputChange = (e)=>{
        const {name, value} = e.target
        setFormData({
            ...formData,
            [name]:value
        })
    }
    
    const checarDadosDeCadastro = async (e)=>{
        e.preventDefault()
        const verificar=(doc)=>{
            console.log(doc)
            if(doc.id){
                navigate('/')
            }
        }
        verificarLogin(formData.email,formData.senha,verificar)
    }
    
     const esqueciMinhaSenha = async ()=>{
        // Reaproveita o e-mail já digitado no campo acima, se tiver. Não
        // precisa de senha nem de estar logado — é exatamente pra quem
        // não consegue entrar.
        if(!formData.email){
            mostrarAviso('Digite seu e-mail no campo acima primeiro', 'aviso')
            return
        }
        setEnviandoRecuperacao(true)
        const resultado = await recuperarSenha(formData.email)
        setEnviandoRecuperacao(false)
        if(!resultado.ok){
            mostrarAviso(resultado.erro, 'erro')
            return
        }
        // Mensagem sempre genérica de propósito (não confirma se o
        // e-mail existe ou não na base — ver comentário em
        // recuperarSenha no CRUD.js).
        mostrarAviso('Se esse e-mail estiver cadastrado, enviamos um link de recuperação.', 'sucesso')
    }

    return(
        <form className={style.login_form} onSubmit={checarDadosDeCadastro}>
            <Input
                label={'Email'}
                name={'email'}
                onChange={handleInputChange}
                value={formData.email}
                required={true}
                placeholder={'Informe seu e-mail'}
            />
            <Input
                label={'Senha'}
                name={'senha'}
                onChange={handleInputChange}
                value={formData.senha}
                required={true}
                placeholder={'••••••••'}
                type='password'
            />
            
            <button type="button" className={style.forgot_password} onClick={esqueciMinhaSenha} disabled={enviandoRecuperacao}>
                {enviandoRecuperacao ? 'Enviando...' : 'Esqueci minha senha'}
            </button>

            <Button type='submit'>
                Entrar
            </Button>
        </form>
    )
}